// React
import { useCallback, useState } from "react";

// Third party imports
import { useDispatch } from "react-redux";

// Redux
import { setError, setSuccess } from "redux/slices/snackbarSlice.jsx";

// APIs
import { updateOperator } from "api/operators.jsx";

const useUpdateOperatorStatus = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const updateOperatorStatus = useCallback(
    async (operatorId, isActive) => {
      setLoading(true);
      try {
        const response = await updateOperator(operatorId, { is_active: isActive });

        if (response.data || response) {
          dispatch(setSuccess(`Operator ${isActive ? 'activated' : 'deactivated'} successfully`));
          return { success: true, data: response.data || response };
        } else {
          dispatch(setError("Failed to update operator status"));
          return { success: false, error: "Failed to update operator status" };
        }
      } catch (error) {
        console.error("Error updating operator status:", error);
        const errorMessage = error?.response?.data?.message ||
                            error?.message ||
                            "Error updating operator status";
        dispatch(setError(errorMessage));
        return { success: false, error: errorMessage };
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  const updateOperatorAnnouncement = useCallback(
    async (operatorId, hasReadLatestAnnouncement) => {
      setLoading(true);
      try {
        await updateOperator(operatorId, {
          has_read_latest_announcement: hasReadLatestAnnouncement
        });
      } catch (error) {
        console.error("Error updating announcement status:", error);
        const errorMessage = error?.response?.data?.message ||
                            error?.message ||
                            "Error updating announcement status";
        dispatch(setError(errorMessage));
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  return {
    updateOperatorStatus,
    updateOperatorAnnouncement,
    loading,
  };
};

export default useUpdateOperatorStatus;
